import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Add, Search } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
const SearchAllServices = ({ handleOpenCreateOrEditPopup }) => {
  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            name="keyword"
            placeholder={"Nhập tên/Mã dịch vụ"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsMultiDatePicker
            label="Ngày đăng ký từ ngày - đến ngày"
            name="fromDate"
            range
            rangeHover
            fromField="fromDate"
            toField="toDate"
            // format={"DD/MM/YYYY"}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={8} className="flex flex-end gap-2">
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(SearchAllServices));
